import { render, staticRenderFns } from "./EventProspections.vue?vue&type=template&id=50ebf09e&scoped=true"
import script from "./EventProspections.vue?vue&type=script&lang=js"
export * from "./EventProspections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ebf09e",
  null
  
)

export default component.exports